import styled from 'styled-components/native';

import { PrimaryDivider } from '../../base_ui';

export const StyledPrimaryDivider = styled(PrimaryDivider)`
  max-width: 100%;
  width: 100%;
`;
